import { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supportedLanguages, SupportedLanguage } from '@/i18n/config';

export default function LocaleRoute() {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();

  const isValidLocale = (locale: string | undefined): locale is SupportedLanguage => {
    return locale !== undefined && supportedLanguages.includes(locale as SupportedLanguage);
  };

  useEffect(() => {
    if (isValidLocale(locale)) {
      if (i18n.language !== locale) {
        i18n.changeLanguage(locale);
      }
    }
  }, [locale, i18n]);

  // Validate locale
  if (!isValidLocale(locale)) {
    return <Navigate to={`/${i18n.language || 'de'}`} replace />;
  }

  return <Outlet />;
}